import Layout from "../components/layout/Layout";
import Hero from "../components/ui/Hero";
import SeoMeta from "../components/common/SeoMeta";  

export default function CookiePolicy() {
  return (
    <Layout>

      {/* ✅ Use SeoMeta for SEO optimization */}
      <SeoMeta
        title="Cookie Policy | SRK Trends"
        description="Understand how SRK Trends uses cookies and how you can manage your preferences."
        keywords="cookie policy, website cookies, data tracking, SRK Trends"
        url="https://www.srktrends.com/cookie-policy"
        image="/images/srk-contact-cookie-policy.png"
      />
      
      {/* ✅ Hero Section */}
      <Hero 
        title="Cookie Policy" 
        image="/images/srk-contact-cookie-policy.png" // 🔹 Replace with a relevant image
      />

      <div className="container mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">Cookie Policy</h1>

        <p className="mb-4 text-gray-700">
          This Cookie Policy explains how SRK Trends uses cookies and similar tracking technologies on our website.
        </p>

        {/* Section 1 - What Are Cookies? */}
        <h2 className="text-2xl font-bold mt-6 mb-4 text-gray-800">1. What Are Cookies?</h2>
        <p className="mb-4 text-gray-700">
          Cookies are small text files stored on your device when you visit a website. They help us improve your browsing experience, understand usage patterns, and provide personalized services.
        </p>

        {/* Section 2 - How We Use Cookies */}
        <h2 className="text-2xl font-bold mt-6 mb-4 text-gray-800">2. How We Use Cookies</h2>
        <ul className="list-disc pl-6 text-gray-700 mb-4">
          <li>To recognize when you visit our website</li>
          <li>To improve security and prevent fraud</li>
          <li>To analyze website traffic and enhance performance</li>
          <li>To remember your preferences for future visits</li>
        </ul>

        {/* Section 3 - Types of Cookies We Use */}
        <h2 className="text-2xl font-bold mt-6 mb-4 text-gray-800">3. Types of Cookies We Use</h2>
        <ul className="list-disc pl-6 text-gray-700 mb-4">
          <li><strong>Essential Cookies:</strong> Required for basic website functions (e.g., login, security).</li>
          <li><strong>Analytics Cookies:</strong> Help us analyze traffic and improve site performance.</li>
          <li><strong>Marketing Cookies:</strong> Used to personalize content and ads.</li>
        </ul>

        {/* Section 4 - Managing Cookies */}
        <h2 className="text-2xl font-bold mt-6 mb-4 text-gray-800">4. How to Manage Cookies</h2>
        <p className="mb-4 text-gray-700">
          You can control or delete cookies through your browser settings. Note that disabling certain cookies may affect website functionality.
        </p>

        {/* Section 5 - Updates & Contact */}
        <h2 className="text-2xl font-bold mt-6 mb-4 text-gray-800">5. Updates & Contact</h2>
        <p className="mb-4 text-gray-700">
          We may update this Cookie Policy from time to time. If you have questions, contact us at:
        </p>
        <p className="text-gray-700">
          <strong>Email:</strong> contact@srktrends.com
        </p>
      </div>
    </Layout>
  );
}